import React, { useState, useEffect } from 'react';
import WorkflowGraph from '../components/WorkFlowGraph';

const Test = () => {
  const [graphData, setGraphData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // For testing, we'll use the sample data you provided
    // In a real app, you would fetch this from your API
    const sampleData = {
      "nodes": {
        "__start__": {
          "id": "__start__",
          "name": "Start",
          "data": {
            "type": "start_node"
          },
          "metadata": null
        },
        "intent_node": {
          "id": "intent_node",
          "name": "Intent Classification",
          "data": {
            "type": "intent_node"
          },
          "metadata": null
        },
        "portfolio_tool_intent_node": {
          "id": "portfolio_tool_intent_node",
          "name": "Portfolio Tool Intent Router",
          "data": {
            "type": "intent_node"
          },
          "metadata": null
        },
        "portfolio_tool_node": {
          "id": "portfolio_tool_node",
          "name": "Portfolio Tool Executor",
          "data": {
            "type": "tool_node"
          },
          "metadata": null
        },
        "portfolio_summary_node": {
          "id": "portfolio_summary_node",
          "name": "Portfolio Summary Node",
          "data": {
            "type": "other"
          },
          "metadata": null
        },
        "__end__": {
          "id": "__end__",
          "name": "End",
          "data": {
            "type": "end_node"
          },
          "metadata": null
        }
      },
      "edges": [
        {
          "source": "__start__",
          "target": "intent_node",
          "data": "show mw top 10 holdings",
          "conditional": false
        },
        {
          "source": "intent_node",
          "target": "portfolio_tool_intent_node",
          "data": "portfolio_tool",
          "conditional": true
        },
        {
          "source": "portfolio_tool_intent_node",
          "target": "portfolio_tool_node",
          "data": "display_portfolio",
          "conditional": false
        },
        {
          "source": "portfolio_tool_node",
          "target": "portfolio_summary_node",
          "data": "__end__",
          "conditional": true
        },
        {
          "source": "portfolio_summary_node",
          "target": "__end__",
          "data": "**Current Portfolio** (USD) | Ticker | Asset Type | Quantity | Purchase Date | Purchase Price |...",
          "conditional": false
        }
      ]
    };

    // Simulate API call
    setTimeout(() => {
      setGraphData(sampleData);
      setLoading(false);
    }, 500);
  }, []);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">Workflow Visualization</h1>

      {loading ? (
        <div className="flex justify-center items-center h-[400px] bg-gray-50 rounded-lg border border-gray-200">
          <div className="text-gray-500">Loading workflow data...</div>
        </div>
      ) : error ? (
        <div className="bg-red-50 text-red-600 p-4 rounded-lg border border-red-200">
          Error loading workflow: {error}
        </div>
      ) : (
        <div className="space-y-6">
          <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Workflow Graph</h2>
            <p className="text-sm text-gray-600 mb-4">
              This visualization shows the flow of data processing from start to end.
            </p>
            <WorkflowGraph graphData={graphData} />
          </div>

          <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
            <h2 className="text-lg font-semibold text-gray-800 mb-2">Raw Data</h2>
            <pre className="bg-gray-50 p-4 rounded-md overflow-auto text-xs text-gray-700 max-h-[300px]">
              {JSON.stringify(graphData, null, 2)}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default Test;